export default __webpack_public_path__ + "static/media/Bell.688b1b67.gif";